import classNames from 'classnames';

import useStyles from './styles';

function ImageSliderWithDynamicTemplatesFallback() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={classNames(styles.title, styles.titleFallback)}>
        <i className="skeleton" />
      </div>
      <div className={styles.sliderFallback}>
        {[...Array(6)].map((_, index) => (
          <i key={index} className="skeleton" />
        ))}
      </div>
    </div>
  );
}

export default ImageSliderWithDynamicTemplatesFallback;
